
<app-home-header [headerData]="data" *ngIf="showHomeHeader"></app-home-header>

<app-header  [headerData]="data" *ngIf="!showHomeHeader"></app-header>


  <router-outlet></router-outlet>


<app-footer></app-footer>

<app-toasts aria-live="polite" aria-atomic="true"></app-toasts>